module.exports = __webpack_public_path__ + "img/quicktips40.4f7ba991.svg";